// Side menu parent open

window.onload = function() {
    var nestedULs = document.querySelectorAll('ul.nested');
    
    nestedULs.forEach(function(ul) {
    
        var currentLinks = ul.querySelectorAll('a.current');
        
        if (currentLinks.length > 0) {
            ul.style.display = 'block';
        }
    });
};

// New product gallery

document.addEventListener("DOMContentLoaded", function () {
  const slides = document.querySelectorAll(".gdy-slide");
  const thumbnails = document.querySelectorAll(".gdy-thumbnail");
  const prevButton = document.querySelector(".gdy-slider-prev");
  const nextButton = document.querySelector(".gdy-slider-next");

  let currentSlide = 0;

  function showSlide(index) {
    slides.forEach((slide, i) => {
      slide.style.display = i === index ? "block" : "none";
    });
    currentSlide = index;
  }

  function nextSlide() {
    const nextIndex = (currentSlide + 1) % slides.length;
    showSlide(nextIndex);
  }

  function prevSlide() {
    const prevIndex = (currentSlide - 1 + slides.length) % slides.length;
    showSlide(prevIndex);
  }

  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener("click", function () {
      const index = parseInt(this.getAttribute("data-index"), 10);
      showSlide(index);
    });
  });

  nextButton.addEventListener("click", nextSlide);
  prevButton.addEventListener("click", prevSlide);
});

// Touch swipe new gallery

document.addEventListener('DOMContentLoaded', function () {
  const slides = document.querySelectorAll('.gdy-slide');
  let currentIndex = 0;
  let startX = 0;
  let endX = 0;

  const slider = document.querySelector('.gdy-slider-wrapper');
  if (!slider) return;

  slider.addEventListener('touchstart', function (e) {
    startX = e.touches[0].clientX;
  });

  slider.addEventListener('touchend', function (e) {
    endX = e.changedTouches[0].clientX;
    const deltaX = endX - startX;

    if (Math.abs(deltaX) > 50) {
      if (deltaX < 0) {
        // Swipe Left → Next Slide
        currentIndex = (currentIndex + 1) % slides.length;
      } else {
        // Swipe Right → Previous Slide
        currentIndex = (currentIndex - 1 + slides.length) % slides.length;
      }
      updateSlide();
    }
  });

  function updateSlide() {
    slides.forEach((slide, index) => {
      if (index === currentIndex) {
        slide.classList.add('active');
      } else {
        slide.classList.remove('active');
      }
    });
  }
});
